const STORAGE_KEY = 'tanzaku-data';

export const saveToLocalStorage = (tanzaku) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(tanzaku));
  } catch (error) {
    console.warn('LocalStorageに保存できませんでした:', error);
  }
};

export const loadFromLocalStorage = () => {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    const parsed = data ? JSON.parse(data) : [];
    return parsed;
  } catch (error) {
    console.warn('LocalStorageから読み込めませんでした:', error);
    return [];
  }
};

export const clearLocalStorage = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.warn('LocalStorageをクリアできませんでした:', error);
  }
};